import React from 'react'
import './index.scss'

const SpinLoader = () => (
    <div className="spin-loader-container center-flex">
        <img src={require('../../../assets/images/logoSpin.png')} className="app-spin-logo" alt="Loading" />
    </div>   
)

export default SpinLoader